export default __webpack_public_path__ + "static/media/SG23.e91042b9.webp";